declare global {
    interface StringConstructor {
        toFormatSeparator(obj: string | number, minimumFractionDigits?: number, maximumFractionDigits?: number): string;
    }

    interface NumberConstructor {
        isNumber(obj: any): boolean;
        toStringByte(obj: number): string;
    }
}

String.toFormatSeparator = function (obj: string | number, minimumFractionDigits: number = 0, maximumFractionDigits: number = 0): string {
    const num = Number(obj);
    return num.toLocaleString(undefined, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits });
};

Number.isNumber = function (obj: any): boolean {
    const num = Number(obj);
    if (Number.isInteger(num))
        return true;
    return false;
};

function toStringByte (bytes: number): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    const i = parseInt(String(Math.floor(Math.log(bytes) / Math.log(1024))),10);
    if (i === 0) return `${bytes} ${sizes[i]})`
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
}

export { }
